module.exports = __webpack_public_path__ + "media/images/img/tag_company/terrasky_tag-fd3bafa61021f68f9cd10e23b55cda59.png";